import { isProd } from 'config/config';
import swal from 'sweetalert';
import {
    getShippingBilling,
    postShippingBilling,
    validateAddress,
    fetchCartSummary,
    API,
    initFortisElements,
    getPaymentInstruments,
    setDefaultFortisPaymentToken,
    deletePaymentToken,
} from 'helpers/api';

import Vue from 'vue/dist/vue';
import VueMask from 'v-mask';

Vue.use(VueMask);

const shippingEl = document.getElementById('shipping-billing');
if (shippingEl) {
    new Vue({
        el: shippingEl,
        data: {
            isLoading: true,
            HasError: false,
            res: null,
            fetchCartRes: null,
            fields: {
                shipVia: {
                    default: {
                        value: '',
                        filled: true,
                    },
                    custom: {
                        value: '',
                        filled: true,
                    },
                },
                shipType: '',
                customShippingAddress: {
                    Name: {
                        value: '',
                        filled: true,
                    },
                    StreetLine1: {
                        value: '',
                        filled: true,
                    },
                    StreetLine2: {
                        value: '',
                    },
                    City: {
                        value: '',
                        filled: true,
                    },
                    State: {
                        value: '',
                        filled: true,
                    },
                    Zip: {
                        value: '',
                        filled: true,
                    },
                    Phone: {
                        value: '',
                        filled: true,
                    },
                },
                customBillingAddress: {
                    Name: {
                        value: '',
                        filled: true,
                    },
                    StreetLine1: {
                        value: '',
                        filled: true,
                    },
                    StreetLine2: {
                        value: '',
                    },
                    City: {
                        value: '',
                        filled: true,
                    },
                    State: {
                        value: '',
                        filled: true,
                    },
                    Zip: {
                        value: '',
                        filled: true,
                    },
                },
                billingType: '',
                paymentOption: null,
                paymentCards: [],
            },
            shipAddressIsDefault: null,
            billingAddressIsDefault: true,
            hasMultiplePaymentTypes: null,
            shipVia: {
                default: null,
                custom: null,
                showCustomShipVias: false,
            },
            addressValidation: {
                suggestedAddress: null,
                addressSelection: 'suggested',
                showSuggestion: false,
                showPOBoxError: false,
                showFailureToValidate: false,
            },
            submissionError: {
                exists: false,
                text: null,
            },
            IsProhibitedState: false,
        },
        computed: {
            isProd() {
                return isProd;
            },
            postValues() {
                const post = {};

                const addItemsToPost = function (fieldsObj, name) {
                    if (name) {
                        post[name] = {};
                        Object.keys(fieldsObj).forEach((key) => {
                            post[name][key] = fieldsObj[key].value;
                        });
                    } else {
                        Object.keys(fieldsObj).forEach((key) => {
                            post[key] = fieldsObj[key].value;
                        });
                    }
                };

                // Add ship via
                if (this.shipAddressIsDefault) {
                    post.ShipVia = this.shipVia.default.find((option) => {
                        return option.Description == this.fields.shipVia.default.value;
                    }).Id;
                } else {
                    post.ShipVia = this.shipVia.custom.find((option) => {
                        return option.Description == this.fields.shipVia.custom.value;
                    }).Id;
                }

                // Add shipping address
                if (this.shipAddressIsDefault) {
                    post.ShippingAddress = {};
                    post.ShippingAddress.Id = null;
                } else {
                    addItemsToPost(this.fields.customShippingAddress, 'ShippingAddress');

                    post.ShippingAddress.Id = 0;
                }

                if (this.fields.billingType === 'CreditCard') {
                    post.TermsCode = 'CreditCard';

                    // Add credit card payment option
                    post.PaymentOption = this.fields.paymentOption;

                    // Add credit card billing addresses
                    if (this.billingAddressIsDefault) {
                        post.ShippingAddressIsBillingAddress = true;
                    } else {
                        addItemsToPost(this.fields.customBillingAddress, 'BillingAddress');

                        post.BillingAddress.Id = 0;
                        post.ShippingAddressIsBillingAddress = false;
                    }
                }

                post.PaymentOption = this.fields.paymentOption;

                return post;
            },
            addressValidationValues() {
                // returns values from shipping address fields in proper formatting to be used with validateAddress function
                const address = {};

                Object.keys(this.fields.customShippingAddress).forEach((item) => {
                    address[item] = this.fields.customShippingAddress[item].value ? this.fields.customShippingAddress[item].value : null;
                });

                return address;
            },
        },
        methods: {
            async setValues() {
                // needed for no pick-up customer messaging from 3/20/2020
                // please remove this and fetchCart/fetchCartRes when this no longer applies
                this.fetchCartRes = await fetchCartSummary();
                // end of 3/20 update

                const shippingRes = await getShippingBilling();
                if (shippingRes.status != 200) {
                    this.HasError = true;

                    console.log('From Shipping Billing JS File', shippingRes.message);

                    this.isLoading = false;

                    swal('Notice', shippingRes.message, 'info');

                    return;
                }

                this.res = shippingRes;

                // function to set non-default values, if there are any
                const setCustomAddress = function (resObj, fieldObj) {
                    Object.keys(resObj).forEach((key) => {
                        if (fieldObj[key] && resObj[key]) {
                            fieldObj[key].value = resObj[key];
                        }
                    });
                };

                // set default shipvias
                this.shipVia.default = shippingRes.defaultCustomerAddress.ShipVias;

                // set current shipping address
                if (shippingRes.CurrentShippingAddress.Id === null) {
                    this.fields.shipType = 'Default';
                    this.shipAddressIsDefault = true;

                    // set shipvias
                    shippingRes.ShipVias.forEach((item) => {
                        if (item.Selected) {
                            this.fields.shipVia.default.value = item.Description;
                        }
                    });
                } else {
                    this.fields.shipType = 'New Address';
                    this.shipAddressIsDefault = false;
                    this.shipVia.validated = true;
                    this.shipVia.showCustomShipVias = true;

                    setCustomAddress(shippingRes.CurrentShippingAddress, this.fields.customShippingAddress);

                    // set shipvias
                    this.shipVia.custom = shippingRes.ShipVias;

                    shippingRes.ShipVias.forEach((item) => {
                        if (item.Selected) {
                            this.fields.shipVia.custom.value = item.Description;
                        }
                    });

                    // Add 'please select' to default ship vias, in case customer switches shipping to default
                    this.shipVia.default.unshift({
                        Description: 'Please Select',
                    });

                    this.fields.shipVia.default.value = 'Please Select';
                }

                // set billing type
                if (shippingRes.AccountTypes.length > 1) {
                    // no saved credit card info in api, so will always default to 'account' on pageload
                    // if more than one billing type, display credit card option
                    this.hasMultiplePaymentTypes = true;

                    this.fields.billingType = 'Account';
                } else {
                    // customer can only pay via credit card
                    this.hasMultiplePaymentTypes = false;

                    this.fields.billingType = 'CreditCard';
                }

                // NOTE: Testing code ONLY
                // if (!this.isProd) {
                //     this.hasMultiplePaymentTypes = false;
                //     this.fields.billingType = 'CreditCard';
                // }

                // set custom billing address, if necessary
                if (!this.billingAddressIsDefault) {
                    setCustomAddress(shippingRes.CurrentBillingAddress, this.fields.customBillingAddress);
                }

                await this.loadCreditCardPaymentOptions(shippingRes.PaymentOption);

                this.isLoading = false;
            },

            async openShipVias() {
                // make sure not shipping to a po box
                if (this.fields.customShippingAddress.StreetLine1.value.toLowerCase().indexOf('po box') >= 0 && !this.res.AllowPOBox) {
                    this.addressValidation.showPOBoxError = true;
                    return;
                }

                // make sure fields are filled
                const filled = this.isSectionFilled(this.fields.customShippingAddress);
                if (!filled) {
                    return;
                }

                this.isLoading = true;

                const res = await validateAddress(this.addressValidationValues);

                this.isLoading = false;

                if (res.ShipVias) {
                    this.shipVia.custom = res.ShipVias;
                    this.shipVia.custom.unshift({
                        Description: 'Please Select',
                    });
                    this.fields.shipVia.custom.value = 'Please Select';
                }

                if (res.IsDifferent) {
                    // if there's an address suggestion, show popup to approve suggested address
                    this.addressValidation.suggestedAddress = res.Addresses[0];
                    this.addressValidation.showSuggestion = true;
                    return;
                } else if (res.IsFailed) {
                    // no suggestion found, show error message
                    this.addressValidation.showFailureToValidate = true;
                    return;
                }

                if (!res.IsDifferent && !res.IsFailed) {
                    // if original address is totally correct
                    // reassign suggested address to make sure everything is UPS-approved
                    this.applySuggestedAddress(res.Addresses[0]);
                    this.shipVia.showCustomShipVias = true;
                }
            },

            hideShipVias() {
                this.shipVia.showCustomShipVias = false;
                this.fields.shipVia.custom.value = '';
            },

            applySuggestedAddress(newAddress) {
                Object.keys(newAddress).forEach((item) => {
                    if (!newAddress[item]) {
                        return;
                    }
                    this.fields.customShippingAddress[item].value = newAddress[item];
                });
            },

            async keepOriginalAddress() {
                // get default residential shipping vias
                const res = await API.address.shippingVia(false);

                if (res.error) {
                    this.submissionError.exists = true;
                    this.submissionError.text =
                        'An error has occurred. Please refresh your page and try again. If issue persists, contact Customer Service at 1-800-527-4007.';
                    return;
                }

                this.shipVia.custom = res;
                this.shipVia.custom.unshift({
                    Description: 'Please Select',
                });

                this.shipVia.showCustomShipVias = true;

                this.fields.shipVia.custom.value = 'Please Select';

                this.addressValidation.showSuggestion = false;
            },

            useSuggestedAddress() {
                this.addressValidation.showSuggestion = false;
                this.applySuggestedAddress(this.addressValidation.suggestedAddress);
                this.openShipVias();
            },

            isSectionFilled(obj) {
                let filled = true;

                // Reusable function to check whether Vue data object fields are blank
                Object.keys(obj).forEach((key) => {
                    // Check if required field
                    if (obj[key].filled !== undefined) {
                        // Check if value exists
                        if (obj[key].value.replace(/\s+/g, '').length) {
                            obj[key].filled = true;
                        } else if (key == 'Phone') {
                            if (!this.fetchCartRes.Freight.IsLTL && !this.res.shippingAddressIsDefault) {
                                obj[key].filled = true;
                            } else {
                                obj[key].filled = false;

                                filled = false;
                            }
                        } else {
                            obj[key].filled = false;

                            filled = false;
                        }
                    }
                });

                return filled;
            },

            isFormFilled() {
                let filled = true;

                // Check if shipping address fields are empty, if necessary
                if (!this.shipAddressIsDefault) {
                    const shipAddressFilled = this.isSectionFilled(this.fields.customShippingAddress);
                    if (!shipAddressFilled) {
                        filled = false;
                    }
                }

                // Check if shipvia filled
                const checkShipVias = function (target) {
                    if (!target.value.length || target.value === 'Please Select') {
                        target.filled = false;

                        return false;
                    }

                    target.filled = true;

                    return true;
                };

                let isShipViaFilled;

                if (this.shipAddressIsDefault) {
                    isShipViaFilled = checkShipVias(this.fields.shipVia.default);
                } else {
                    isShipViaFilled = checkShipVias(this.fields.shipVia.custom);
                }

                if (!isShipViaFilled) {
                    filled = false;
                }

                // Check if billing address fields are empty, if necessary
                if (!this.billingAddressIsDefault && this.fields.billingType === 'CreditCard') {
                    const billAddressfilled = this.isSectionFilled(this.fields.customBillingAddress);
                    if (!billAddressfilled) {
                        filled = false;
                    }
                }

                // Check if credit card fields is empty, if necessary
                if (this.fields.billingType === 'CreditCard') {
                    if (!this.fields.paymentOption || this.fields.paymentOption === '') {
                        filled = false;

                        this.showError('A default payment card is required. Please select a default card or add a new card to continue.');
                    }
                }

                return filled;
            },

            showError(message) {
                this.submissionError.exists = true;
                this.submissionError.text = message;
            },

            selectUnvalidatedAddress() {
                this.addressValidation.showFailureToValidate = false;
                this.shipVia.showCustomShipVias = true;
            },

            async submitForm(e) {
                e.preventDefault();

                // Check whether necessary fields are filled out
                const filled = this.isFormFilled();
                if (!filled) {
                    return;
                }

                // Check if custom shipping address is valid, if necessary

                this.post();
            },

            async post(ignoreRedirect = false) {
                const res = await postShippingBilling(this.postValues);
                if (res.status !== 200) {
                    this.submissionError.exists = true;

                    if (res.Message) {
                        this.submissionError.text = res.Message;
                    } else {
                        this.submissionError.text = 'An error has occurred. If issue persists, please contact Customer Service at 1-800-527-4007.';
                    }

                    return;
                }

                if (!ignoreRedirect) {
                    window.location = document.getElementById('submit-button').getAttribute('href');
                }
            },

            // Fortis Methods
            setupFortisElements(shippingRes) {
                const self = this;

                const onTokenizeDone = async (tokenizeResponseData) => {
                    await self.loadCreditCardPaymentOptions(tokenizeResponseData.PaymentOption);
                };

                initFortisElements('#fortis-card-element', shippingRes, onTokenizeDone);
            },

            async loadCreditCardPaymentOptions(paymentOption = null) {
                const self = this;

                // Load saved payment cards for the customer, if any exist
                self.fields.paymentCards = await getPaymentInstruments();

                // Set payment option to saved card if it exists, otherwise it will be set to null and customer will have to select a card or enter new card info
                self.fields.paymentOption = paymentOption;
            },

            setDefaultPaymentCard(paymentCard) {
                const self = this;

                swal({
                    title: `Are you sure you want to set ${paymentCard.mask} as your default card?`,
                    text: 'This card will be used as your default payment method for future purchases.',
                    icon: 'warning',
                    buttons: ['Cancel', 'Set Default'],
                }).then(async (result) => {
                    if (result) {
                        self.isLoading = true;

                        try {
                            const res = await setDefaultFortisPaymentToken(paymentCard);
                            if (!res) {
                                self.isLoading = false;
                                return;
                            }

                            // Update the UI immediately to reflect the change in default payment option
                            self.fields.paymentOption = paymentCard.id;

                            swal('Success', 'Your default card has been set.', 'success');
                        } catch (error) {
                            swal({
                                title: 'Error setting default card',
                                text: error.message || 'An error occurred while setting your default card. Please try again.',
                                icon: 'error',
                            });
                        } finally {
                            self.isLoading = false;
                        }
                    }
                });
            },

            removePaymentCard(paymentCard) {
                const self = this;

                swal({
                    title: `Are you sure you want to remove ${paymentCard.mask}?`,
                    text: 'This card will be removed from your account and cannot be used for future purchases unless added again.',
                    icon: 'warning',
                    buttons: ['Cancel', 'Remove Card'],
                    dangerMode: true,
                }).then(async (willDelete) => {
                    if (willDelete) {
                        self.isLoading = true;

                        try {
                            const res = await deletePaymentToken(paymentCard);
                            if (!res) {
                                self.isLoading = false;
                                return;
                            }

                            // If this card was the currently selected payment option, reset it so user has to select a different card or enter new card info
                            if (self.fields.paymentOption === paymentCard.id) {
                                self.fields.paymentOption = null;
                            }

                            // Remove token from local state to update UI
                            this.fields.paymentCards = this.fields.paymentCards.filter((t) => t.id !== paymentCard.id);

                            // If the removed card was the currently selected payment option, reset it so user has to select a different card or enter new card info
                            if (this.fields.paymentOption && this.fields.paymentOption.TokenId === paymentCard.id) {
                                this.fields.paymentOption = null;
                            }

                            swal('Removed', 'Your card has been removed.', 'success');
                        } catch (error) {
                            swal({
                                title: 'Error deleting card',
                                text: error.message || 'An error occurred while deleting your card. Please try again.',
                                icon: 'error',
                            });
                        } finally {
                            self.isLoading = false;
                        }
                    }
                });
            },
        },
        async mounted() {
            await this.setValues();

            if (this.res) {
                this.setupFortisElements(this.res);
            }
        },
    });
}

function init() {}

export default init;
